import { useTheme } from '@mui/material/styles';
import { URLS, FONTS, DISPLAY_NAME } from '../../config/app-config';
// src/components/user/UserPortal.js
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton,
    Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import UserLists from './collections/UserLists';
import { useAuth } from '../../auth/AuthProvider';

/**
 * UserPortal
 * Props:
 *  - user: OIDC user object from AuthProvider
 *  - open: boolean — whether the dialog is open
 *  - onClose: fn — called to close the dialog
 */

const UserPortal = ({
    open,
    onClose,
    fetchArticle
}) => {
    const theme = useTheme();

    const {
        user,
        isAuthenticated,
        login
    } = useAuth();

    const apiBase = `${URLS.apiBase}/user`;
    const articleBase = URLS.apiBase;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle
                disableTypography
                sx={{ m: 0, p: 0, bgcolor: theme.palette.primary.main, color: 'common.white' }}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    px={2}
                    py={1}
                >
                    <Box display="flex" alignItems="center">
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{ fontFamily: FONTS.heading, fontWeight: 700, mr: 1 }}
                        >
                            {DISPLAY_NAME}
                        </Typography>
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{ fontFamily: FONTS.heading, fontWeight: 300 }}
                        >
                            Collections
                        </Typography>
                    </Box>
                    <IconButton edge="end" color="inherit" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent>
                <Box sx={{ width: '100%', height: '500px', display: 'flex', flexDirection: 'column' }}>
                    <UserLists
                        user={user}
                        apiBase={apiBase}
                        articleBase={articleBase}
                        isAuthenticated={isAuthenticated}
                        login={login}
                        fetchArticle={fetchArticle}
                    />

                    <Box sx={{ flexGrow: 1 }} />

                    <Divider sx={{ my: 2 }} />

                    <Typography sx={{ fontFamily: FONTS.body, color: '#4f4f4f' }} gutterBottom>
                        You can store articles in custom collections that allow you to access them later.
                        To add an article or create a new collection, click the + Icon next to its title in the reader page.
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default UserPortal;

